<template>
  <div class="lg:flex lg:justify-center lg:mt-10">
    <header class="font-open-sans p-5 lg:p-10 lg:rounded-lg bg-blue-900 border-b-8 border-orange-400">
      <h2 class="text-xl md:text-3xl font-bold text-gray-100">Dobro došli u</h2>
      <h1 class="text-3xl md:text-6xl font-black text-white mt-1 md:mt-3">JU Druga gimnazija Sarajevo</h1>
      <h4 class="text-sm md:text-xl text-gray-100 mt-2 md:mt-4 max-w-6xl">Poštovani učenici budućih prvih razreda Druge
        gimnazije,
        želimo vam poželjeti dobrodošlicu u našu školu, te vas zamoliti da popunite sljedeće obavezne podatke pri
        upisu.</h4>
      <h4 class="text-sm md:text-xl text-gray-100 mt-2 md:mt-4 max-w-6xl">Nakon uspješne prijave preuzet će Vam se PDF datoteka koju je potrebno isprintati i potpisati. Ukoliko Vam se po prijavi ne preuzme
        PDF datoteka sa popunjenom anketom, obratite nam se na mail: upis@2gimnazija.edu.ba</h4>
    </header>
  </div>
</template>
<script setup>
</script>